import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance"
import type { AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
    allow403?: boolean;
};

export const confirmPayAdsTopUp = (payload: {
    fees: number,
    amount: number,
    account_id: string,
    bill_id: number,
    service_id: number
}) => {
    return axiosPrivate.post('/bills/api/v1/converted-pay/confirm-top-up/', payload, { allow403: true } as CustomAxiosRequestConfig);
}

